import { render, staticRenderFns } from "./RepresentativeCommissionPercentage.vue?vue&type=template&id=34604a00&"
import script from "./RepresentativeCommissionPercentage.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeCommissionPercentage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports